import { gql } from '@apollo/client';

export const ADD_UPDATE_APPROVAL_TYPE_LEVEL = gql`
  mutation addOrUpdateApprovalTypeLevel($input: AddOrUpdateApprovalTypeLevelInput) {
    addOrUpdateApprovalTypeLevel(input: $input) {
      commandId
    }
  }
`;
